module.exports = "/_next/static/images/a459dbb729aae171792ea87b97620275-rotativo_valor_total.png";